<template>
  <v-container class="pa-0" fluid>
    <v-row>
      <!-- Titel oben rechts (10 breit) -->
      <v-col cols="12" sm="12">
        <v-text-field v-model="form.title" :class="readonly ? 'custom-readonly' : ''" :readonly="readonly" label="Titel"
                      title="Titel" :variant="useGlobalSetting().globalTextVariant"></v-text-field>
      </v-col>
    </v-row>

    <v-row>

      <!-- Beschreibung (10 breit) -->
      <v-col cols="12" sm="12">
        <v-textarea
            v-model="form.description"
            :class="readonly ? 'custom-readonly' : ''"
            :readonly="readonly"
            label="Beschreibung"
            no-resize
            title="Beschreibung"
            :variant="useGlobalSetting().globalTextVariant"
        ></v-textarea>
      </v-col>
    </v-row>

    <v-row>
      <!-- AKZ und Autor untereinander (2 breit, gleiche Höhe wie Beschreibung) -->
      <v-col class="d-flex flex-column" cols="12" sm="4">
        <v-text-field v-model="form.id" :class="readonly ? 'custom-readonly' : ''" :readonly="readonly" label="ID"
                      title="ID" :variant="useGlobalSetting().globalTextVariant"></v-text-field>
        <v-text-field v-model="form.author" :class="readonly ? 'custom-readonly' : ''" :readonly="readonly"
                      label="Autor"
                      title="Autor" :variant="useGlobalSetting().globalTextVariant"></v-text-field>
      </v-col>
      <v-col class="d-flex flex-column" cols="12" sm="4">
        <v-text-field v-model="form.asset_id" :class="readonly ? 'custom-readonly' : ''" :readonly="readonly" label="AKZ"
                      title="AKZ" :variant="useGlobalSetting().globalTextVariant"></v-text-field>
        <PrioritySelect v-model="form.priority" :readonly="readonly" :variant="useGlobalSetting().globalTextVariant"/>
      </v-col>

      <v-col cols="12" sm="4">
        <StateSelect v-model="form.state" :class="readonly ? 'custom-readonly' : ''" :readonly="readonly"
                     :variant="useGlobalSetting().globalTextVariant"/>
        <TimepickerSmall v-model="form.scheduled_duration" :readonly="readonly" label="Solldauer"/>
      </v-col>
    </v-row>
    <v-row>

      <!-- Sollstart mit Date Picker (5 breit) -->
      <v-col cols="12" sm="6">
        <v-text-field
            v-model="ss"
            :class="readonly ? 'custom-readonly' : ''"
            :readonly="readonly"
            label="Sollstart"
            title="Sollstart"
            type="datetime-local"
            :variant="useGlobalSetting().globalTextVariant"
        ></v-text-field>
      </v-col>

      <!-- Solldauer mit Date Picker (5 breit) -->
      <v-col cols="12" sm="6">
        <v-text-field
            v-model="form.scheduled_end"
            :class="readonly ? 'custom-readonly' : ''"
            :readonly="readonly"
            label="Sollende"
            title="Sollende"
            type="datetime-local"
            :variant="useGlobalSetting().globalTextVariant"
        ></v-text-field>
      </v-col>
    </v-row>
    <!--test/-->
  </v-container>
</template>

<script lang="ts" setup>
import {reactive, watch} from 'vue'
import PrioritySelect from "@/components/inputs/PrioritySelect.vue";
import TimepickerSmall from "@/components/inputs/TimepickerSmall.vue";
import StateSelect from "@/components/inputs/StateSelect.vue";
import {Order} from "@/types/Order";
import {useGlobalSetting} from "@/lib/utils";

const ss = "2025-05-22T15:00:00"

const record = defineModel<Order>();

const props = defineProps({
  readonly: {
    type: Boolean,
    default: false
  }
})

//const emit = defineEmits(["change"])

watch(record, newVal => {
  useGlobalSetting().hasChanged = true;
  //emit('change', newVal)
})

/*const form = ref({
  id: '',
  akz: '',
  author: '',
  title: '',
  description: '',
  prio: '',
  sollStart: '',
  sollDauer: '',
  state: '',
  duration: '',
  reply: '',
})*/

const form = reactive(record)
</script>
